import { createSelector } from 'reselect';

const getPlpTopBanner = (
  state: import('../types/rootState').RootState
): import('../types/plpTopBanner').PlpTopBanner => state.plpTopBanner;

const getPlpTopBannerImages = createSelector(
  getPlpTopBanner,
  ({ returningUserImageUrl, newUserImageUrl }) => ({
    returningUserImageUrl,
    newUserImageUrl
  })
);

export default getPlpTopBannerImages;
